<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

// Price in the storefront voice: bold integer, small superscript cents,
// currency after. Always EUR — the backend prices everything in cents of EUR.
const props = withDefaults(
  defineProps<{ cents: number; size?: 'sm' | 'md' | 'lg' }>(),
  { size: 'md' },
);

const { locale } = useI18n();

const parts = computed(() => {
  const euros = Math.floor(props.cents / 100);
  const cents = Math.abs(props.cents % 100);
  return {
    euros: euros.toLocaleString(locale.value),
    cents: cents.toString().padStart(2, '0'),
  };
});

const sizes = {
  sm: { main: 'text-[15px]', sup: 'text-[10px]', cur: 'text-[11px]' },
  md: { main: 'text-[20px]', sup: 'text-[11px]', cur: 'text-[12px]' },
  lg: { main: 'text-[32px]', sup: 'text-[14px]', cur: 'text-[16px]' },
} as const;
</script>

<template>
  <span class="inline-flex items-start font-bold leading-none tabular-nums text-text">
    <span class="sr-only">{{ parts.euros }},{{ parts.cents }} €</span>
    <span aria-hidden="true" :class="sizes[size].main">{{ parts.euros }}</span>
    <span aria-hidden="true" :class="[sizes[size].sup, 'mt-[2px] font-semibold text-text-dim']">,{{ parts.cents }}</span>
    <span aria-hidden="true" :class="[sizes[size].cur, 'ml-1 mt-[2px] font-semibold text-text-dim']">€</span>
  </span>
</template>
